export default "__VITE_ASSET__ff02823b__"